module.exports = {"gender":{"male":117,"female":0},"provider_type":{"psychologist":81,"psychiatrist":36},"call_channel":{"phone":40,"web":77},"tag":{"Depression":{"id":20,"count":2}},"returning":{"time6+":3},"patient_feedback":{"good":43,"bad":1,"null":73},"provider_feedback":{"good":59,"bad":2,"null":56},"Department":[{"id":-1,"count":1},{"id":92,"count":116},{"id":91,"count":1}],"NewOOCAAttr":[{"id":-1,"count":117},{"id":90,"count":1}],"PHA":[{"id":-1,"count":118}]}


//////////////////
// WEBPACK FOOTER
// ./src/_mockup/counseling_report_select.json
// module id = 1878
// module chunks = 0